var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__bar",style:({ width: _vm.progressBarWidth })})])
}
var staticRenderFns = []

export { render, staticRenderFns }